
class Storage {
  get(key: string){
    const value = localStorage.getItem(key);
    if(value) return value;
    return undefined;
  } 

  set(key: string, value: string){
    localStorage.setItem(key, value);
  }

  remove(key: string){
    localStorage.removeItem(key);
  }
}

export const storage = new Storage();